module.exports = "/images/achraf.jpg?8ae23072507c0e940f2a07e5b5192ddb";